// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__Niy9r"};